/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface RejectRequest {
  rejection_reason_id?: string | null;
  note?: string | null;
}
